import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../lib/utils";
import * as React from "react";
const Separator = React.forwardRef(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (React.createElement(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn("shrink-0", "bg-separator", orientation === "horizontal"
        ? "h-[1px] min-w-full"
        : "min-h-full w-[1px] self-stretch", className !== null && className !== void 0 ? className : ""), ...props })));
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
//# sourceMappingURL=Separator.js.map